flatpickr(".datepicker__placeholder-input", {
  disableMobile: "true"
});
